module.exports = __webpack_public_path__ + "img/mockinterview-heading=mobile.c943ff37.svg";